export type NavMatch = "exact" | "prefix";

export type NavItem = {
  label: string;
  path: string;
  match: NavMatch;
};

export const primaryNavItems: NavItem[] = [
  { label: "Account", path: "/account", match: "exact" },
  { label: "Subscriptions", path: "/subscriptions", match: "exact" },
  { label: "Webhooks", path: "/webhooks", match: "prefix" },
];

export const getVisiblePrimaryNavItems = (isEnterprise?: boolean): NavItem[] =>
  isEnterprise
    ? primaryNavItems.filter((item) => item.path === "/account")
    : primaryNavItems;

export const isNavItemActive = (pathname: string, item: NavItem): boolean => {
  if (item.match === "prefix") {
    return pathname === item.path || pathname.startsWith(`${item.path}/`);
  }

  return pathname === item.path;
};
